import { useState } from 'react';
import { MapPin } from 'lucide-react';
import { formatLocation } from '../data/functions';
import LocationButton from './LocationButton';
import ManualLocationButton from './ManualLocationButton';

/**
 * Location selector component for displaying and editing user location
 * Shows current location with GPS and manual location buttons in edit mode
 */
export default function LocationSelector({ location, editable = false }) {
  const [status, setStatus] = useState(null); // 'success' | 'error' | null
  const [statusText, setStatusText] = useState('');

  const handleMessage = ({ message, type }) => {
    setStatus(type);
    setStatusText(message);
    setTimeout(() => setStatus(null), 3000);
  };

  if (editable) {
    return (
      <div>
        <label className="mb-1 block text-xs font-semibold uppercase tracking-wide text-primary">Location</label>
        <div className="flex items-center gap-2 rounded-lg border border-input bg-background px-3 py-2 text-sm text-foreground">
          <MapPin size={14} />
          {/* Display current location or placeholder text */}
          <span className="flex-1 truncate">{location || 'Tap GPS or Edit Icons => '}</span>
          {/* GPS button - uses browser geolocation to set current location */}
          <LocationButton iconOnly onMessage={handleMessage} />
          {/* Manual location button - opens modal to search and set location manually */}
          <ManualLocationButton onMessage={handleMessage} />
        </div>
        {status && (
          <p className={`mt-1 text-xs text-center ${status === 'success' ? 'text-green-500' : 'text-red-500'}`}>
            {statusText}
          </p>
        )}
      </div>
    );
  }

  // View mode - just display location with icon
  return (
    <div className="flex items-center gap-1 max-w-[60%]">
      <MapPin size={14} className="shrink-0" />
      {/* Format and display location, or show dash if not set */}
      <span className="truncate">{formatLocation(location) || '—'}</span>
    </div>
  );
}
